import { ReportService } from "./../../reportes/reports";
import { ApiBasic } from "./../../services/api-basic";
import { MatDialogRef } from "@angular/material";
import { GridOptions } from "ag-grid/main";
import { GlobalServiceService } from "src/app/services/global-service.service";
import { FiltersProvider } from "./../filters";
import { Component, OnInit } from "@angular/core";
import { MaintenanceProvider } from "src/app/reportes/maintenance";

@Component({
  selector: "app-select-recorrido",
  templateUrl: "./select-recorrido.component.html",
  styleUrls: ["./select-recorrido.component.css"],
})
export class SelectRecorridoComponent implements OnInit {
  testSelec;
  testArray: any = [];
  flagDatapoint: boolean = false;
  profile;
  imagenes: any = [];
  test;
  loading: boolean = false;
  imgActivo: boolean = false;
  recorridoFlag: boolean = false;
  constructor(
    private _filter: FiltersProvider,
    private maintenanceService: MaintenanceProvider,
    private _report: ReportService,
    public _global: GlobalServiceService,
    public dialogRef: MatDialogRef<SelectRecorridoComponent>,
    private api: ApiBasic
  ) {
    this.profile = this._global.getUserInfo();
  }

  ngOnInit() {

    this.getRecorrido();
  }

  selectRecorrido(event) {
    this.testSelec = event
    if (event) {
      this.loading = true;
      this.imgActivo = false;
      this._report
        .getRecorridoImg(event.id)
        .subscribe((res: any) => {
          let test = res.map((element) => ({
            ...element,
            rutamap: this._global.base_image_url + element.ruta,
          }));
          this.imagenes = test;
          this.loading = false;
          this.imgActivo = true;
        });
    }
  }

  getRecorrido() {

    this._report.getRecorridoUsuario(this.profile.id).subscribe((res: any) => {
      this.recorridoFlag = res.length == 0 ? true : false;

      this.flagDatapoint = true;
      this.testArray = JSON.parse(
        JSON.stringify(res).replace(/descripcion/g, "name")
      ).map((item) => {
        item.id = item.id.toString();
        return item;
      });
      this.imagenes = this.testArray;
    });
  }

  seleccionarImangen(item) {
    if (item) {
      this._report.getConvertirImgBase(item["rutamap"]).subscribe(
        (res) => {
          item["rutamap64"] = "data:image/jpeg;base64," + res["image"];
          item == false
            ? this.dialogRef.close({ data: item, close: true })
            : this.dialogRef.close({
                data: item,
                close: false,
                recorrido: this.testSelec[0],
              });
        },
        (erro) => {
          this.dialogRef.close({ data: item, close: true });
        }
      );
    } else {
      this.dialogRef.close({ data: item, close: true });
    }
  }
}
